"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CategoryTemplate = function CategoryTemplateComponent(_ref) {
  var dataClient = _ref.dataClient,
      title = _ref.title,
      subtitle = _ref.subtitle,
      image = _ref.image;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "responsive-hero-category__wrapper",
    style: {
      backgroundImage: "url('".concat(image.url, "')")
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "responsive-hero-category__text"
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "responsive-hero-category__title"
  }, dataClient.textToMarkdown(title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "responsive-hero-category__description"
  }, dataClient.renderFullMarkup(subtitle)))));
};

CategoryTemplate.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  subtitle: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  image: _propTypes["default"].shape({}).isRequired
};
var _default = CategoryTemplate;
exports["default"] = _default;